import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appScrollto]'
})
export class ScrolltoDirective implements AfterViewInit {
  private _selected: boolean;

  @Input('selected') public set _setSelected(selected: boolean) {
    this._selected = selected;

    if (this._selected && this.element) {
      this.element.nativeElement.scrollIntoView();
    }
  }

  constructor(
    private element: ElementRef
  ) { }

  ngAfterViewInit(): void {
    if (this._selected) {
      this.element.nativeElement.scrollIntoView();
    }
  }

}
